module.exports = __webpack_public_path__ + "img/ruse.419d7e65.jpg";